"use client";

import { useTraceStore } from "@/store/useTraceStore";
import { LAYER_COLORS, PANEL } from "@/config/constants";

export default function LayerToggles() {
  const layers = useTraceStore((s) => s.layers);
  const toggleLayer = useTraceStore((s) => s.toggleLayer);

  return (
    <div className="absolute bottom-16 sm:bottom-24 left-3 sm:left-5 z-20 flex flex-row sm:flex-col gap-1" role="group" aria-label="Visualization layers">
      {(["cables", "infra", "arcs", "events"] as const).map((layer) => {
        const color = LAYER_COLORS[layer];
        return (
          <button
            key={layer}
            onClick={() => toggleLayer(layer)}
            role="switch"
            aria-checked={layers[layer]}
            aria-label={`${layer.charAt(0).toUpperCase() + layer.slice(1)} layer`}
            className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-[11px] transition-all duration-200 cursor-pointer ${
              layers[layer] ? "text-[#A1A1AA]" : "text-[#71717A] opacity-50"
            }`}
            style={{
              background: layers[layer] ? PANEL.BG : "rgba(13, 13, 26, 0.50)",
              border: `1px solid ${layers[layer] ? `${color}33` : "rgba(255,255,255,0.03)"}`,
            }}
          >
            <div
              className="w-1.5 h-1.5 rounded-full"
              style={{ background: layers[layer] ? color : "#71717A" }}
              aria-hidden="true"
            />
            {layer.charAt(0).toUpperCase() + layer.slice(1)}
          </button>
        );
      })}
    </div>
  );
}
